var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import { Upload, Button, Row, Col, Typography, App } from "antd";
import { UploadOutlined, FileImageOutlined } from "@ant-design/icons";
var Text = Typography.Text;
var SvgIconUpload = function (_a) {
    var value = _a.value, onChange = _a.onChange;
    var message = App.useApp().message;
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var _c = useState(""), fileName = _c[0], setFileName = _c[1];
    var handleUpload = function (file) {
        // 验证文件类型
        if (file.type !== "image/svg+xml" && !file.name.endsWith(".svg")) {
            message.error("只支持SVG格式的图标文件！");
            return false;
        }
        // 验证文件大小（限制在50KB内）
        if (file.size > 50 * 1024) {
            message.error("SVG文件大小不能超过50KB！");
            return false;
        }
        setLoading(true);
        setFileName(file.name);
        // 读取文件内容
        var reader = new FileReader();
        reader.onload = function (e) {
            var _a;
            var svgContent = (_a = e.target) === null || _a === void 0 ? void 0 : _a.result;
            try {
                // 清理和验证SVG内容
                svgContent = cleanSvgContent(svgContent);
                if (onChange) {
                    onChange(svgContent);
                }
                setLoading(false);
                message.success("SVG图标上传成功");
            }
            catch (error) {
                setLoading(false);
                setFileName("");
                message.error("SVG格式无效，请检查文件内容");
            }
        };
        reader.onerror = function () {
            setLoading(false);
            setFileName("");
            message.error("读取文件失败");
        };
        reader.readAsText(file);
        return false; // 阻止默认上传
    };
    // 清理SVG内容
    var cleanSvgContent = function (svgContent) {
        // 移除BOM和多余的空白字符
        svgContent = svgContent.replace(/^\uFEFF/, "").trim();
        // 验证是否是有效的SVG
        if (!svgContent.includes("<svg") || !svgContent.includes("</svg>")) {
            throw new Error("无效的SVG格式");
        }
        // 移除可能的危险属性和脚本
        svgContent = svgContent
            .replace(/on\w+="[^"]*"/gi, "") // 移除事件处理器
            .replace(/javascript:/gi, "") // 移除javascript协议
            .replace(/<script[^>]*>[\s\S]*?<\/script>/gi, "") // 移除script标签
            .replace(/style="[^"]*javascript[^"]*"/gi, ""); // 移除包含javascript的style
        // 确保SVG有viewBox或width/height
        if (!svgContent.includes("viewBox") &&
            !svgContent.includes("width") &&
            !svgContent.includes("height")) {
            // 添加默认的viewBox
            svgContent = svgContent.replace("<svg", '<svg viewBox="0 0 24 24"');
        }
        return svgContent;
    };
    var handleClear = function () {
        onChange === null || onChange === void 0 ? void 0 : onChange("");
        setFileName("");
    };
    return (_jsxs("div", __assign({ style: { width: "100%" } }, { children: [_jsxs(Row, __assign({ justify: "space-between", style: { marginBottom: 12 } }, { children: [_jsx(Col, { children: _jsx(Upload, __assign({ accept: ".svg,image/svg+xml", showUploadList: false, beforeUpload: handleUpload }, { children: _jsx(Button, __assign({ icon: _jsx(UploadOutlined, {}), loading: loading, type: "default" }, { children: "\u4E0A\u4F20SVG" })) })) }), _jsx(Col, { children: value && (_jsx(Button, __assign({ onClick: handleClear, type: "text", danger: true }, { children: "\u6E05\u9664" }))) })] })), _jsx("div", __assign({ style: {
                    marginBottom: 12,
                    minHeight: "20px",
                    display: "flex",
                    alignItems: "center",
                } }, { children: fileName && (_jsx(Text, __assign({ type: "secondary", style: { fontSize: "13px" } }, { children: fileName }))) })), _jsx("div", __assign({ className: "svg-upload-preview", style: {
                    width: "calc(100% - 16px)",
                    height: "80px",
                    border: "1px solid #d9d9d9",
                    borderRadius: "6px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    paddingLeft: "16px",
                    backgroundColor: "#fafafa",
                } }, { children: value ? (_jsx("div", { className: "tag-icon-container", dangerouslySetInnerHTML: { __html: value }, style: {
                        width: 48,
                        height: 48,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    } })) : (_jsx(FileImageOutlined, { style: { color: "#d9d9d9", fontSize: 48 } })) }))] })));
};
export default SvgIconUpload;
